const colorHexMap = {
    black: '#000000',
    white: '#ffffff',
    grey: '#f5f5f5'
};

export { colorHexMap };
//# sourceMappingURL=color-map.js.map
